import { T } from '../lib/design-tokens';

interface UsageBarProps {
  label: string;
  used: number;
  total: number | null;
  color?: string;
}

export function UsageBar({ label, used, total, color = T.gold }: UsageBarProps) {
  return (
    <div className="mb-4">
      <div
        className="flex justify-between mb-2 text-[13px]"
        style={{ color: T.cream60, fontFamily: T.sans }}
      >
        <span>{label}</span>
        <span className="font-mono text-xs" style={{ color: T.cream20 }}>
          {total != null ? `${used} / ${total}` : String(used)}
        </span>
      </div>
      {total != null && total > 0 && (
        <div
          className="h-[3px] rounded-[2px] overflow-hidden"
          style={{ background: T.cream04 }}
        >
          <div
            className="h-full rounded-[2px]"
            style={{
              background: color,
              width: `${Math.min(100, (used / total) * 100)}%`,
              transition: 'width 1s cubic-bezier(0.4,0,0.2,1)',
            }}
          />
        </div>
      )}
    </div>
  );
}
